import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { KnowledgebaseService } from 'src/app/core/services/knowledgebase/knowledgebase.service';

@Component({
  selector: 'add-knowledgebase',
  templateUrl: './add-knowledgebase.component.html',
  styleUrls: ['./add-knowledgebase.component.scss'],
  providers: [MessageService],
})
export class AddKnowledgebaseComponent implements OnInit {
  @Output() closeAddSidebar = new EventEmitter();
  @Input() knowledgebaseId: string;
  @Input() viewOrEdit: number;
  // Form field bindings
  name: string = '';
  description: string = '';
  selectedVectorStore: string;
  vectorStoreUrl: string = '';
  vectorStoreUsername: string = '';
  vectorStorePassword: string = '';
  titile: string;
  editData: any;
  viewModeOn: boolean;
  isUrlInvalid: boolean = false;
  isNameInvalid:boolean = false;
  buttonText: string;
  knowledgeBaseDropDownList: any;
  constructor(private knowledgebaseService: KnowledgebaseService, private messageService: MessageService,) { }

  ngOnInit(): void {
    this.viewModeOn = false;
    this.buttonText = "Submit"
    if (this.knowledgebaseId) {
      if (this.viewOrEdit === 2) {
        this.titile = "Edit"
        this.buttonText = "Update"
      } else if (this.viewOrEdit === 3) {
        this.titile = "View"
        this.viewModeOn = true;
      }

      this.editFun(this.knowledgebaseId)
    } else {
      this.titile = "Add"
    }
    this.getDropDownsJson();
  }


  getDropDownsJson() {
    this.knowledgebaseService.getKnowledgeBaseJsonDropdown().subscribe((res: any) => {
      if (res.flag) {
        this.knowledgeBaseDropDownList = JSON.parse(res.data);
      }
    });
  }

  isValidUrl(url: string): boolean {
    const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
    return urlPattern.test(url);
  }

  checkUrlValidity() {
    this.isUrlInvalid = !this.isValidUrl(this.vectorStoreUrl);
  }

  // checkNameValidity(){
  //   const alphanumericRegex = /^[a-zA-Z0-9 ]+$/;

  //   if (!this.name || alphanumericRegex.test(this.name)) {
  //     this.isNameInvalid = false;
  //   } else {
  //     this.isNameInvalid = true;
  //   }
  // }

  isFormValid(): boolean {
    // Name validation
    if (!this.name) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Name is required.',
      });
      return false;
    }
 this.checkNameValidity();
    if (this.isNameInvalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Name must contain only letters, numbers, underscores (_) or hyphens (-). No spaces or special characters allowed.',
      });
      return false;
    }
    // Vector Store validation
    if (!this.selectedVectorStore) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select a Vector Store.',
      });
      return false;
    }
  
    // Additional validation for 'External' Vector Store
    if (this.selectedVectorStore === 'External') {
      if (!this.vectorStoreUrl || this.isUrlInvalid) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Please enter a valid Vector Store URL.',
        });
        return false;
      }
  
      if (!this.vectorStoreUsername) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Please enter a Vector Store Username.',
        });
        return false;
      }
  
      if (!this.vectorStorePassword) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Please enter a Vector Store Password.',
        });
        return false;
      }
    }
  
    // All validations passed
    return true;
  }
  


  onVectorStoreChange(selectedValue: string): void {
    if (selectedValue !== 'External') {
        // Clear external fields when VectorStore is not 'External'
        this.vectorStoreUrl = null;
        this.vectorStoreUsername = null;
        this.vectorStorePassword = null;
        this.isUrlInvalid = false; // Reset URL validity flag
    }
}


  editFun(id) {
    this.knowledgebaseService.getKnowledgeBaseById(id).subscribe((res) => {
      if (res.flag) {
        const editData = JSON.parse(res.data.config);
        this.name = res.data.name;
        this.description = res.data.description;
        this.selectedVectorStore = editData.storage;
        this.vectorStoreUrl = editData.vectorStoreUrl;
        this.vectorStoreUsername = editData.vectorStoreUsername;
        this.vectorStorePassword = editData.vectorStorePassword;
      }
    });
  }

  /**
   * Submit the form after validation
   */
  onSubmit() {
    if (!this.isFormValid()) {
      return;
    }

    const config: any = {
      storage: this.selectedVectorStore || null,
      vectorStoreUrl: this.vectorStoreUrl || null,
      vectorStoreUsername: this.vectorStoreUsername || null,
      vectorStorePassword: this.vectorStorePassword || null,
    };

    // Final payload
    const payload: any = {
      config: JSON.stringify(config), // Stringify the entire config object
      name: this.name,
      description: this.description,
      storage: this.selectedVectorStore,
    };

    if (this.knowledgebaseId) {
      payload.knowledge_base_guid = this.knowledgebaseId;
    }
    
    this.knowledgebaseService.createKnowledgeBase(payload).subscribe((res) => {
      if (res.flag) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message,
        });
        setTimeout(() => {
          if (this.knowledgebaseId) {
            this.closeAddSidebar.emit(false);
          } else {
            this.closeAddSidebar.emit(true);
          }
        }, 1000);
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: res.message,
        });
      }
    });
  }

  close() {
    this.closeAddSidebar.emit(false)
  }

 onReset() {
    this.name = '';
    this.description = '';
    this.selectedVectorStore = null;
    this.isNameInvalid = false;
    this.vectorStoreUrl = '';
    this.vectorStoreUsername = '';
    this.vectorStorePassword = '';
  }

  checkNameValidity() {
  // Allow only: a-z, A-Z, 0-9, underscore, hyphen
  const validNameRegex = /^[a-zA-Z0-9_-]+$/;

  this.isNameInvalid = !validNameRegex.test(this.name);
}
allowValidNameChars(event: KeyboardEvent): boolean {
  const allowedRegex = /^[a-zA-Z0-9_-]$/;
  const inputChar = String.fromCharCode(event.charCode);
  if (!allowedRegex.test(inputChar)) {
    event.preventDefault();
    return false;
  }
  return true;
}

}
